import React, { useEffect, useRef, useState } from 'react';
import { Globe, CaretDown, Check } from '@phosphor-icons/react';
import { useWorkerLang } from '../contexts/WorkerLanguageContext';

const LANGS = [
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'es', label: 'Español', flag: '🇲🇽' },
];

export const LanguageMenu = ({ compact = false }) => {
  const { lang, setLang } = useWorkerLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  useEffect(() => {
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey); };
  }, []);

  return (
    <div className="relative" ref={ref} data-testid="language-menu">
      <button
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors ${compact ? 'h-9 px-2 text-sm' : 'h-10 px-3 text-sm'}`}
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label="Change language"
        data-testid="language-menu-btn"
      >
        <Globe size={16} weight="bold" />
        <span className="leading-none">{current.flag}</span>
        {!compact && <span className="font-semibold hidden lg:inline">{current.code.toUpperCase()}</span>}
        <CaretDown size={12} weight="bold" className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-44 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-lg overflow-hidden z-[60]"
          role="listbox"
          data-testid="language-menu-list"
        >
          {LANGS.map((l) => (
            <button
              key={l.code}
              onClick={() => { setLang(l.code); setOpen(false); }}
              className={`w-full flex items-center gap-2.5 px-3.5 py-2.5 text-sm text-left hover:bg-gray-50 dark:hover:bg-gray-700 ${l.code === lang ? 'font-bold text-blue-600 dark:text-blue-400' : 'text-gray-700 dark:text-gray-300'}`}
              role="option"
              aria-selected={l.code === lang}
              data-testid={`language-option-${l.code}`}
            >
              <span className="text-lg leading-none">{l.flag}</span>
              <span className="flex-1">{l.label}</span>
              {l.code === lang && <Check size={15} weight="bold" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageMenu;
